<template>
  <div class="relative py-4">

    <vs-row class="flex justify-between items-center mb-4">
      <h5 v-if="!!title" class="flex items-center"><i class="dot"></i>{{ title }}</h5>
      <div v-else></div>
      <div v-if="controls && !readonly && !isPrint">
        <vs-button v-if="this.form.organizations.length < maxCol"color="secondary" @click="handleAddRow"> {{ $t(buttonAddName) }} </vs-button>
        <vs-button v-if="this.form.organizations.length > 1" class="ml-4" color="secondary" type="border" @click="handleRemoveRow"> {{ $t(buttonRemoveName) }} </vs-button>
      </div>
    </vs-row>

    <div style="overflow-x: auto; position: relative;" :style="{
      paddingBottom: showMenuNode.showMenu ? '140px' : '0px'
    }" @click="onClickTable">
      <table class="mb-4 table-wrap" >

        <!-- 테이블의 col 사이즈를 정하는 부분 -->
        <colgroup>
          <template v-for="organization in form.organizations">
            <col style="min-width:200px;">
          </template>
        </colgroup>

        <!-- head -->
        <thead style="position: sticky; top:0; z-index:1;">
          <tr >
            <template v-for="organization in form.organizations">
              <th class="p-1 th-cell">
                <label v-if="organization.component === 'label'" class="w-full h-full flex items-center justify-center">{{$t(organization.name)}}</label>
                <component v-else :is="organization.component" v-model="organization.name" :display-text="$t(organization.name)" :use-display-text="true"/>
              </th>
            </template>
          </tr>
        </thead>

        <!-- body -->
        <tbody>
          <template v-for="(data, dIdx) in tableData">
            <tr >
              <template v-for="(organization, oIdx) in form.organizations">
                <td v-if="organization.lv === getChild(data, organization.lv).lv"
                    class="p-1 border-right border-bottom"
                    :rowspan="getChild(data, organization.lv).rowspan"
                    :set="(child = getChild(data, organization.lv))"
                >
                  <div class="w-full h-full grid items-center " style="grid-template-columns: 1fr auto; position: relative;">
                    <edit-input v-if="!child.empty"
                                v-model="child.name"
                                :readonly="!child.edit"
                                type="label-and-input"
                                @input="(value) => {
                                  onChangeName(value, getChild(data, organization.lv).raw)
                                }"></edit-input>
                    <div v-if="!child.empty && !child.edit">
                      <div class="flex items-center">
                        <feather-icon class="ml-auto" icon="MoreHorizontalIcon" style="cursor: pointer;" @click.stop="onClickNodeToggleMenu(getChild(data, organization.lv).raw)"/>
                      </div>
                      <div
                        v-if="child.showMenu"
                        style="position: absolute; z-index: 1; right:0;"
                      >
                        <div class="subMenuPopup">
                          <!-- 마지막 열은 하위조직 생성 불가 -->
                          <div v-if="oIdx < form.organizations.length-1" class="p-2 flex items-center cursor-pointer"
                               @click="onClickAddChildNode(getChild(data, organization.lv).raw,(form.organizations[oIdx+1]) ? form.organizations[oIdx+1].name : '')">
                            <feather-icon icon="PlusIcon" />
                            <span class="ml-2">{{ $t('하위조직생성') }}</span>
                          </div>

                          <!-- 위로 이동-->
                          <div v-if="changedNodeSort(getChild(data, organization.lv).parent,getChild(data, organization.lv).raw, -1)"
                               class="p-2 flex items-center cursor-pointer"
                               @click="onClickChangeNodeSort(getChild(data, organization.lv).parent,getChild(data, organization.lv).raw, -1)">
                            <feather-icon icon="ArrowUpIcon" />
                            <span class="ml-2">{{ $t('위로 이동') }}</span>
                          </div>

                          <!-- 아래로 이동-->
                          <div v-if="changedNodeSort(getChild(data, organization.lv).parent,getChild(data, organization.lv).raw, 1)"
                               class="p-2 flex items-center cursor-pointer"
                               @click="onClickChangeNodeSort(getChild(data, organization.lv).parent,getChild(data, organization.lv).raw, 1)">
                            <feather-icon icon="ArrowDownIcon" />
                            <span class="ml-2">{{ $t('아래로 이동') }}</span>
                          </div>

                          <!-- 명칭변경 -->
                          <div class="p-2 flex items-center cursor-pointer"
                               @click="onClickChangeNodeName(getChild(data, organization.lv).raw)">
                            <feather-icon icon="EditIcon" />
                            <span class="ml-2">{{ $t('명칭변경') }}</span>
                          </div>

                          <!-- 0,0 번째 노드는 삭제 숨기기 -->
                          <div v-if="!(dIdx === 0 && oIdx === 0)" class="p-2 flex items-center cursor-pointer"
                               @click="onClickDelNode(getChild(data, organization.lv).parent,getChild(data, organization.lv).raw)">
                            <feather-icon icon="Trash2Icon" />
                            <span class="ml-2">{{ $t('삭제') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EditInput from "@/components/EditInput.vue";

export default {
  name: "TableOrganogram",
  components: {EditInput},
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    value: Object,
    controls: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    title: String,
    buttonAddName: {
      type: String,
      default: "열 추가",
    },
    buttonRemoveName: {
      type: String,
      default: "마지막 열 삭제",
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed :{
    tableData () {
      if (this.count > 100) {
        this.count = 0
      }
      // const list = [
      //   {
      //     child: [
      //       { lv: 1, name:'강서구청장' },
      //       { lv: 2, name:'Level 2' },
      //       { lv: 3, name:'Level 3' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 3, name:'Level 3' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 3, name:'Level 3' },
      //       { lv: 4, name:'Level 4' },
      //       { lv: 5, name:'Level 5' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 5, name:'Level 5' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 4, name:'Level 4' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 2, name:'Level 2' },
      //       { lv: 3, name:'Level 3' },
      //       { lv: 4, name:'Level 4' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 1, name:'강서구청장' },
      //       { lv: 2, name:'Level 2' },
      //       { lv: 3, name:'Level 3' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 3, name:'Level 3'},
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 3, name:'Level 3'},
      //       { lv: 4, name:'Level 4' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 4, name:'Level 4' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 2, name:'Level 2' },
      //       { lv: 3, name:'Level 3' },
      //       { lv: 4, name:'Level 4' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 2, name:'Level 2' },
      //       { lv: 3, name:'Level 3' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 3, name:'Level 3' },
      //       { lv: 4, name:'Level 4' },
      //     ]
      //   },
      //   {
      //     child: [
      //       { lv: 4, name:'Level 4' },
      //     ]
      //   },
      // ]
      const list = []; //this.form.data
      for (const item of this.form.data) {
        const parent = undefined
        const child = []
        list.push({child})
        this.convertTreeToTable(list, parent, child, item, 1)
      }

      // rowspan 계산하기
      for (let i=0; i<list.length; i++) {
        const iRow = list[i];
        for (let a=0; a<iRow.child.length; a++) {
          const iCol = iRow.child[a]
          let rowspan = 1;
          for (let j=i+1; j<list.length; j++) {
            const jRow = list[j];
            const jCol = jRow.child[0]
            if (iCol.lv < jCol.lv) {
              rowspan++;
            } else {
              break;
            }
          }
          iCol.rowspan = rowspan
        }
      }

      // child 의 마지막 lv이 조직도 마지막 등급 보다 높은 경우
      // 마지막 등급까지 빈 데이터를 넣어준다.
      // table의 border 를 넣기 위해 추가했다.
      for (const row of list) {
        const lastLv = row.child.length > 0 ? row.child[row.child.length-1].lv : -1
        for (let lv = lastLv + 1; lv <= this.form.organizations.length; lv++) {
          row.child.push({ lv, name:'', empty: true, })
        }
      }

      return list
    }
  },
  mounted() {

  },
  data() {
    return {
      /** count : form.data가 변경되었을 때 표를 업데이트 시켜주기위해 사용 */
      count: 0,

      /** maxCol : 추가할 수 있는 최대 등급 수 */
      maxCol: 20,

      /** showMenu : 열려있는 서브 메뉴 */
      showMenuNode: {},

      form: {
        /** organizations : 조직 등급 리스트
         조직도의 등급별 레벨과 이름을 저장하고 있다.
         표의 head 부분을 담당한다.
         */
        organizations: [
          { lv: 1, name: "경영책임자", component: 'label' },
          { lv: 2, name: "안전보건관리 책임자", component: 'edit-input' },
          { lv: 3, name: "중대재해 총괄부서", component: 'edit-input' },
          { lv: 4, name: "부서", component: 'edit-input' },
          { lv: 5, name: "관리감독자", component: 'edit-input' },
          { lv: 6, name: "사업장", component: 'edit-input' },
          { lv: 7, name: "Level 7", component: 'edit-input' },
        ],

        data: [{
          name:'Level 1',
          edit: false,
          showMenu: false,
          child: [
            {
              name:'Level 2',
              edit: false,
              showMenu: false,
              child: [
                {
                  name:'Level 3',
                  edit: false,
                  showMenu: false,
                  child: [
                    {
                      name:'Level 4',
                      edit: false,
                      showMenu: false,
                      child: [
                        {
                          name:'Level 5',
                          edit: false,
                          showMenu: false,
                          child: [
                            {
                              name:'Level 6',
                              edit: false,
                              showMenu: false,
                              child: [
                                {
                                  name:'Level 7',
                                  edit: false,
                                  showMenu: false,
                                  child: []
                                }
                              ]
                            }
                          ]
                        },
                        {
                          name:'Level 5',
                          edit: false,
                          showMenu: false,
                          child: [
                            {
                              name:'Level 6',
                              edit: false,
                              showMenu: false,
                              child: [
                                {
                                  name:'Level 7',
                                  edit: false,
                                  showMenu: false,
                                  child: []
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      name:'Level 4',
                      edit: false,
                      showMenu: false,
                      child: [
                        {
                          name:'Level 5',
                          edit: false,
                          showMenu: false,
                          child: [
                            {
                              name:'Level 6',
                              edit: false,
                              showMenu: false,
                              child: [
                                {
                                  name:'Level 7',
                                  edit: false,
                                  showMenu: false,
                                  child: []
                                }
                              ]
                            }
                          ]
                        },
                        {
                          name:'Level 5',
                          edit: false,
                          showMenu: false,
                          child: [
                            {
                              name:'Level 6',
                              edit: false,
                              showMenu: false,
                              child: [
                                {
                                  name:'Level 7',
                                  edit: false,
                                  showMenu: false,
                                  child: []
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      name:'Level 4',
                      edit: false,
                      showMenu: false,
                      child: [
                        {
                          name:'Level 5',
                          edit: false,
                          showMenu: false,
                          child: [
                            {
                              name:'Level 6',
                              edit: false,
                              showMenu: false,
                              child: [
                                {
                                  name:'Level 7',
                                  edit: false,
                                  showMenu: false,
                                  child: []
                                }
                              ]
                            }
                          ]
                        },
                        {
                          name:'Level 5',
                          edit: false,
                          showMenu: false,
                          child: [
                            {
                              name:'Level 6',
                              edit: false,
                              showMenu: false,
                              child: [
                                {
                                  name:'Level 7',
                                  edit: false,
                                  showMenu: false,
                                  child: []
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                  ]
                }
              ]
            }
          ]
        }],
      }
    };
  },

  methods: {
    getChild (data, lv) {
      if (data && data.child.length > 0) {
        for (const child of data.child) {
          if (child.lv === lv) {
            return child;
          }
        }
      }

      return {
        lv: -1,
        name: '',
      }
    },

    /**
     * convertTreeToTable: form.data 를 table 에 사용하는 data 로 변환한다.
     */
    convertTreeToTable (list, parent, _child, item, lv) {
      let child = _child
      let lastLv = _child.length > 0 ? _child[child.length-1].lv : -1
      if (lv > lastLv) {
        // 추가하려는 lv이 이미 _child 에 존재하는 경우

      } else {
        // 추가하려는 lv이 _child 에 없는 경우
        child = []
        list.push({child: child})
      }

      // 들어가는 내용
      child.push({
        id: '',
        lv: lv,
        name: item.name,
        raw: item,
        parent: parent,

        edit: item.edit,
        showMenu: item.showMenu
      })

      const subChild = item.child ? item.child : []
      for (const sub of subChild) {
        this.convertTreeToTable(list, item, child, sub, lv+1)
      }

    },

    /**
     * 자식 노드를 추가한다.
     */
    onClickAddChildNode (raw, def) {
      if (!raw.child) {
        raw.child = []
      }
      raw.child.push({
        name: def ? def : 'New',
        edit: false,
        showMenu: false,
      })
      this.count++;
    },
    /**
     * 노드를 삭제한다.
     */
    onClickDelNode (parent, raw) {
      if (parent && parent.child) {
        parent.child.remove(raw)
        this.count++;
      }
    },
    /**
     * 노드이름을 변경한다
     */
    onClickChangeNodeName (raw) {
      raw.edit = true
      this.count++;
    },
    /**
     * 노드의 메뉴를 펼친다
     */
    onClickNodeToggleMenu (raw) {
      if (this.showMenuNode !== raw) {
        this.showMenuNode.showMenu = false
        this.showMenuNode = raw
      }
      this.showMenuNode.showMenu = !this.showMenuNode.showMenu

      // 열린 메뉴가 없는 경우 변수를 초기화 한다.
      if (!this.showMenuNode.showMenu) {
        this.showMenuNode = {}
      }
      this.count++;
    },
    /**
     * 노드의 상하 순서를 변경한다.
     */
    onClickChangeNodeSort (parent, raw, sort) {
      const index = parent.child.indexOf(raw)
      let nextIndex = index + sort
      nextIndex = nextIndex < 0 ? 0 : nextIndex
      this.moveValue(parent.child, index, nextIndex)
    },
    /**
     * 노드의 상하 순서 변경이 가능한지 체크
     */
    changedNodeSort (parent, raw, sort) {
      if (!parent) {
        return false
      }
      const index = parent.child.indexOf(raw)
      let nextIndex = index + sort
      if (nextIndex < 0) {
        return false
      }
      if (nextIndex >= parent.child.length) {
        return false
      }
      return true
    },
    moveValue(array, fromIndex, toIndex) {
      const item = array.splice(fromIndex, 1)[0];
      array.splice(toIndex, 0, item);
    },
    onChangeName(name, raw){
      raw.name = name
      raw.edit = false
    },
    onClickTable () {
      if (this.showMenuNode) {
        this.showMenuNode.showMenu = false;
      }
    },
    handleAddRow() {
      if (this.form.organizations.length < this.maxCol) {
        // 마지막 데이터를 기준으로 lv 을 높여서 추가
        const lastData = this.form.organizations[this.form.organizations.length-1]
        const nextLv = lastData.lv + 1
        this.form.organizations.push({
          lv : nextLv,
          name: `Level ${nextLv}`,
          component: 'edit-input'
        })
      }
    },
    handleRemoveRow() {
      if (this.form.organizations.length > 1) {
        this.form.organizations.pop();
      }
    },
  },
}
</script>

<style scoped lang="scss">
td {
  vertical-align: top;
}
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.table-wrap {
  width: 100%;
  border-spacing: 0;
  border-left: 1px solid #cdcdcd;
}

.th-cell {
  white-space: nowrap;
  border-top: 1px solid #cdcdcd;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.subMenuPopup {
  display: grid;
  width: 150px;
  background-color: #fff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);

  & > div:hover {
    background-color: #7E72F2;
    color: #fff;
  }
}
</style>
